<footer>
    <div class="container-fluid px-3 px-md-3 px-lg-4 px-xl-5 pb-4">
        <div class="row g-lg-4 g-md-4 g-4">
            <div class="col-md-3">
                <div class="footer-logo">
                    <a href="#"><img src="assets/images/ICICI-Bank-Blue-Logo.png"></a>
                </div>
                <p>ICICI Bank Towers,<br>
                    Bandra-Kurla Complex, <br>
                    Mumbai 400 051.</p>
            </div>
            <div class="col-md-3">
                <p><strong>Others</strong></p>
              <!--  <p><a href="#" routerLink="faq" routerLinkActive="is-active">FAQs</a></p> -->
              <!--<p><a href="#" routerLink="terms-conditions" routerLinkActive="is-active">Terms & Conditions</a></p>-->
              <p><a href="https://www.icicibank.com/terms-condition" routerLinkActive="is-active">Terms & Conditions</a></p>
             <p><a href="https://www.icicibank.com/privacy" routerLinkActive="is-active">Privacy Policy</a></p>
             <!-- <p><a href="{{Icici_privacy_url}}" target="_blank">Privacy Policy</a></p> -->
            </div>
            <div class="col-md-3">
                <p><strong>Help & Support</strong></p>
                <p>Contact Us : <a href="tel:18001080"> 1800 1080</a></p>
                <p>Email : <a href="mailto:{{mailto}}" class="link">{{mailto}}</a></p>
            </div>
            <div class="col-md-3">
                <a mat-raised-button color="primary" href="{{bankLogin}}" target="_blank">Bank Login</a>
            </div>
        </div>
        <hr class="mt-5 mb-4">
        <p class="mb-2 text-center">&copy; ICICI Bank Ltd All Rights Reserved</p>
    </div>
</footer>
